module.exports = __webpack_public_path__ + "static/img/EH.24f88ff1.png";